module.exports = __webpack_public_path__ + "mo/img/publisher.6824194c.webp";